// VNEC v9 — pages/hd-detail.js
// Trang "Chi tiết HĐ 360°" — header + KPI + 5 tab dữ liệu liên quan
import { rpc } from '../lib/supabase.js';
import { formatVND, esc, stateLabel } from '../lib/forms.js';

let _state = { current: null, currentTab: 'items', maHd: null, allHd: [] };

// ════════════════════════════════════════════════════════════
// MAIN RENDER
// ════════════════════════════════════════════════════════════
export async function renderHdDetail(maHd) {
  _state.maHd = maHd;
  window.__pageInit = init;
  return `
    <div class="page hd360-page">
      <div class="hd360-picker-bar">
        <div class="hd360-picker">
          <input type="search" id="hd-search" class="input-search"
                 placeholder="🔍 Tìm hợp đồng theo mã, tên, nhà thầu..." autocomplete="off">
          <div id="hd-dropdown" class="hd360-dropdown" style="display:none"></div>
        </div>
        ${maHd ? '<a href="#/hop-dong" class="btn btn-ghost btn-sm">← Danh sách HĐ</a>' : ''}
      </div>
      <div id="hd-content">
        ${maHd
          ? '<div class="loading center" style="padding:3rem">Đang tải chi tiết hợp đồng...</div>'
          : emptyState()}
      </div>
    </div>`;
}

function emptyState() {
  return `
    <div class="hd360-empty">
      <div class="hd360-empty-icon">📄</div>
      <h2>Chọn một hợp đồng để xem chi tiết</h2>
      <p>Sử dụng ô tìm kiếm phía trên để chọn hợp đồng. Trang sẽ hiển thị toàn bộ phụ lục, đơn hàng, chi phí và phiếu thanh toán liên quan.</p>
    </div>`;
}

async function init() {
  const search = document.getElementById('hd-search');
  const dropdown = document.getElementById('hd-dropdown');
  let timer;

  search.addEventListener('input', () => {
    clearTimeout(timer);
    timer = setTimeout(() => loadPicker(search.value), 200);
  });
  search.addEventListener('focus', () => loadPicker(search.value));

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.hd360-picker')) dropdown.style.display = 'none';
  });

  if (_state.maHd) await loadHd(_state.maHd);
}

// ════════════════════════════════════════════════════════════
// HD PICKER (search dropdown)
// ════════════════════════════════════════════════════════════
async function loadPicker(query) {
  const dropdown = document.getElementById('hd-dropdown');
  try {
    const data = await rpc('list_hd_for_picker', { p_search: query || null, p_limit: 50 });
    _state.allHd = data || [];
    if (!_state.allHd.length) {
      dropdown.innerHTML = '<div class="hd360-dd-empty">Không có hợp đồng phù hợp</div>';
    } else {
      dropdown.innerHTML = _state.allHd.map(h => `
        <div class="hd360-dd-item" data-ma="${esc(h.ma_hd)}">
          <div class="hd360-dd-ma">${esc(h.ma_hd)}</div>
          <div class="hd360-dd-sub">${esc(h.nha_thau || '—')} · ${esc(h.ma_du_an || '—')}</div>
        </div>`).join('');
      dropdown.querySelectorAll('.hd360-dd-item').forEach(it => {
        it.addEventListener('click', () => {
          const ma = it.dataset.ma;
          dropdown.style.display = 'none';
          document.getElementById('hd-search').value = ma;
          window.location.hash = '#/hd-detail/' + encodeURIComponent(ma);
        });
      });
    }
    dropdown.style.display = 'block';
  } catch (e) {
    dropdown.innerHTML = `<div class="hd360-dd-empty">Lỗi: ${esc(e.message)}</div>`;
    dropdown.style.display = 'block';
  }
}

// ════════════════════════════════════════════════════════════
// LOAD HD 360
// ════════════════════════════════════════════════════════════
async function loadHd(maHd) {
  const wrap = document.getElementById('hd-content');
  wrap.innerHTML = '<div class="loading center" style="padding:3rem">Đang tải...</div>';
  try {
    const data = await rpc('get_hd_360', { p_ma_hd: maHd });
    if (!data || data.error) {
      wrap.innerHTML = `<div class="hd360-empty"><div class="hd360-empty-icon">⚠</div><h2>Không tìm thấy hợp đồng</h2><p>Mã hợp đồng "${esc(maHd)}" không tồn tại hoặc đã bị xóa.</p></div>`;
      return;
    }
    _state.current = data;
    renderHd();
  } catch (e) {
    wrap.innerHTML = `<div class="hd360-empty"><div class="hd360-empty-icon">⚠</div><h2>Lỗi tải dữ liệu</h2><p>${esc(e.message)}</p></div>`;
  }
}

function renderHd() {
  const d = _state.current;
  const h = d.header;
  const k = d.kpi;
  const c = d.counts;

  const stateBadge = h.trang_thai === 'approved'
    ? `<span class="hd360-state ok">● Đã duyệt</span>`
    : h.trang_thai === 'pending_l1' || h.trang_thai === 'pending_l2'
      ? `<span class="hd360-state warn">● Chờ duyệt</span>`
      : h.trang_thai === 'rejected'
        ? `<span class="hd360-state rej">● Từ chối</span>`
        : `<span class="hd360-state">${esc(h.trang_thai)}</span>`;

  const html = `
    <div class="hd360-card">
      <div class="hd360-top">
        <div>
          <h2 class="hd360-title">${esc(h.ma_hd || '')}</h2>
          <div class="hd360-sub">${esc(h.ten_hd || '')} ${h.nha_thau ? '· ' + esc(h.nha_thau) : ''}</div>
        </div>
        ${stateBadge}
      </div>
      <div class="hd360-meta">
        <div><span>Dự án</span><b>${esc(h.ma_du_an || '—')}${h.ten_du_an ? ' — ' + esc(h.ten_du_an) : ''}</b></div>
        <div><span>Ngày ký</span><b>${formatDate(h.ngay_ky)}</b></div>
        <div><span>Người tạo</span><b>${esc(h.created_by_name || '—')}</b></div>
        <div><span>Phân loại</span><b>${esc(h.phan_loai_hd || '—')}${h.is_hdnt ? ' (HDNT)' : ''}</b></div>
      </div>
    </div>

    <div class="hd360-kpi">
      <div class="hd360-kpi-c">
        <div class="hd360-kpi-l">${k.is_hdnt ? 'Tổng đơn hàng đã duyệt' : 'Giá trị HĐ gốc'}</div>
        <div class="hd360-kpi-v">${formatVND(k.is_hdnt ? k.gia_tri_dh : k.gia_tri_goc)} đ</div>
        ${k.is_hdnt
          ? `<div class="hd360-kpi-s">${c.don_hang} đơn hàng</div>`
          : (k.gia_tri_pl > 0
              ? `<div class="hd360-kpi-s">+ phụ lục: ${formatVND(k.gia_tri_pl)} đ</div>`
              : '<div class="hd360-kpi-s">&nbsp;</div>')}
      </div>
      <div class="hd360-kpi-c ok">
        <div class="hd360-kpi-l">Đã thanh toán</div>
        <div class="hd360-kpi-v">${formatVND(k.da_tt)} đ</div>
        <div class="hd360-kpi-s">${k.tt_pct}% tổng giá trị</div>
        <div class="hd360-progress"><div style="width:${Math.min(k.tt_pct, 100)}%"></div></div>
      </div>
      <div class="hd360-kpi-c warn">
        <div class="hd360-kpi-l">Còn lại</div>
        <div class="hd360-kpi-v">${formatVND(k.con_lai)} đ</div>
        <div class="hd360-kpi-s">${(100 - k.tt_pct).toFixed(1)}% chưa TT</div>
      </div>
      <div class="hd360-kpi-c">
        <div class="hd360-kpi-l">Tổng giá trị</div>
        <div class="hd360-kpi-v">${formatVND(k.gia_tri_total)} đ</div>
        <div class="hd360-kpi-s">${k.is_hdnt
          ? `${formatVND(k.gia_tri_dh)} ĐH${k.gia_tri_pl > 0 ? ` + ${formatVND(k.gia_tri_pl)} PL` : ''}`
          : `${formatVND(k.gia_tri_goc)} HĐ${k.gia_tri_pl > 0 ? ` + ${formatVND(k.gia_tri_pl)} PL` : ''}`}</div>
      </div>
    </div>

    <div class="hd360-tabs" id="hd360-tabs">
      ${tabBtn('items',    'Hạng mục',    c.items)}
      ${tabBtn('plhd',     'Phụ lục',     c.plhd)}
      ${tabBtn('don_hang', 'Đơn hàng',    c.don_hang)}
      ${tabBtn('chi_phi',  'Chi phí',     c.chi_phi)}
      ${tabBtn('pyctt',    'Phiếu YCTT',  c.pyctt)}
    </div>

    <div class="card hd360-tab-card">
      <div id="hd360-tab-content"></div>
    </div>`;

  document.getElementById('hd-content').innerHTML = html;

  document.querySelectorAll('#hd360-tabs .hd360-tab').forEach(t => {
    t.addEventListener('click', () => switchTab(t.dataset.tab));
  });
  switchTab(_state.currentTab || 'items');
}

function tabBtn(key, label, count) {
  const cls = (_state.currentTab || 'items') === key ? 'hd360-tab on' : 'hd360-tab';
  return `<button class="${cls}" data-tab="${key}">${label} <span class="hd360-tab-cnt">${count || 0}</span></button>`;
}

function switchTab(tab) {
  _state.currentTab = tab;
  document.querySelectorAll('#hd360-tabs .hd360-tab').forEach(b => {
    b.classList.toggle('on', b.dataset.tab === tab);
  });
  const el = document.getElementById('hd360-tab-content');
  el.innerHTML = renderTab(tab);
  // Wire row clicks
  el.querySelectorAll('tbody tr[data-href]').forEach(r => {
    r.addEventListener('click', () => { window.location.hash = r.dataset.href; });
  });
}

// ════════════════════════════════════════════════════════════
// TAB CONTENT
// ════════════════════════════════════════════════════════════
function renderTab(tab) {
  const d = _state.current;
  const maHd = d.header.ma_hd;
  switch (tab) {
    case 'items':    return renderItemsTab(d.items);
    case 'plhd':     return renderPlhdTab(d.plhd, maHd);
    case 'don_hang': return renderDhTab(d.don_hang, maHd, d.header.is_hdnt);
    case 'chi_phi':  return renderCpTab(d.chi_phi, maHd);
    case 'pyctt':    return renderPycTab(d.pyctt, maHd);
  }
  return '';
}

function tabHeader(title, btnText, onClick) {
  return `
    <div class="hd360-tab-hd">
      <h4>${title}</h4>
      ${btnText ? `<button class="btn btn-primary btn-sm" onclick="${onClick}">+ ${btnText}</button>` : ''}
    </div>`;
}

function emptyRow(cols, text) {
  return `<tr><td colspan="${cols}" class="muted center" style="padding:1.5rem">${text}</td></tr>`;
}

function renderItemsTab(items) {
  const total = (items || []).reduce((s, r) => s + Number(r.thanh_tien || 0), 0);
  return `
    ${tabHeader('Hạng mục hợp đồng')}
    <div class="table-wrap"><table class="table">
      <thead><tr>
        <th>#</th><th>Nội dung</th><th>ĐVT</th>
        <th class="num">Số lượng</th><th class="num">Đơn giá</th>
        <th class="num">Thành tiền</th><th>Loại CP</th><th>Mã VT</th>
      </tr></thead>
      <tbody>
        ${(items && items.length)
          ? items.map((it, i) => `
            <tr>
              <td class="c">${i + 1}</td>
              <td>${esc(it.noi_dung || '')}</td>
              <td>${esc(it.don_vi || '')}</td>
              <td class="num">${formatVND(it.so_luong || 0)}</td>
              <td class="num">${formatVND(it.don_gia || 0)}</td>
              <td class="num bold">${formatVND(it.thanh_tien || 0)}</td>
              <td class="small">${esc(it.loai_cp || '')}</td>
              <td class="small">${esc(it.ma_vat_tu || '')}</td>
            </tr>`).join('')
          : emptyRow(8, 'Hợp đồng này chưa có hạng mục nào.')}
        ${items && items.length ? `
          <tr class="ttl">
            <td colspan="5" class="num"><strong>TỔNG</strong></td>
            <td class="num bold">${formatVND(total)}</td>
            <td colspan="2"></td>
          </tr>` : ''}
      </tbody>
    </table></div>`;
}

function renderPlhdTab(rows, maHd) {
  return `
    ${tabHeader('Phụ lục hợp đồng', 'Tạo phụ lục', `window.location.hash='#/phu-luc'`)}
    <div class="table-wrap"><table class="table">
      <thead><tr>
        <th>Mã PL</th><th>Nội dung</th>
        <th class="num">Giá trị</th><th>Loại CP</th>
        <th>Người tạo</th><th>Ngày tạo</th><th>Trạng thái</th>
      </tr></thead>
      <tbody>
        ${(rows && rows.length)
          ? rows.map(r => `
            <tr data-href="#/phu-luc">
              <td><strong>${esc(r.so_plhd || '')}</strong></td>
              <td class="small">${esc(r.noi_dung || '—')}</td>
              <td class="num">${formatVND(r.gia_tri || 0)}</td>
              <td class="small">${esc(r.loai_cp || '—')}</td>
              <td class="small">${esc(r.created_by_name || '—')}</td>
              <td class="small">${formatDate(r.created_at)}</td>
              <td>${stateLabel(r.trang_thai)}</td>
            </tr>`).join('')
          : emptyRow(7, 'Chưa có phụ lục nào.')}
      </tbody>
    </table></div>`;
}

function renderDhTab(rows, maHd, isHdnt) {
  const note = !isHdnt
    ? '<div class="hd360-note">💡 Hợp đồng này không phải HĐ Nguyên tắc, thông thường không có đơn hàng đi kèm.</div>'
    : '';
  return `
    ${tabHeader('Đơn hàng', 'Tạo đơn hàng', `window.location.hash='#/don-hang'`)}
    ${note}
    <div class="table-wrap"><table class="table">
      <thead><tr>
        <th>Mã ĐH</th><th>Nội dung</th>
        <th class="num">Tổng giá trị</th>
        <th>Ngày ĐH</th><th>Người tạo</th><th>Trạng thái</th>
      </tr></thead>
      <tbody>
        ${(rows && rows.length)
          ? rows.map(r => `
            <tr data-href="#/don-hang">
              <td><strong>${esc(r.so_dh || '')}</strong></td>
              <td class="small">${esc(r.noi_dung || '—')}</td>
              <td class="num bold">${formatVND(r.tong_gia_tri || 0)}</td>
              <td class="small">${formatDate(r.ngay_dh)}</td>
              <td class="small">${esc(r.created_by_name || '—')}</td>
              <td>${stateLabel(r.trang_thai)}</td>
            </tr>`).join('')
          : emptyRow(6, 'Chưa có đơn hàng nào.')}
      </tbody>
    </table></div>`;
}

function renderCpTab(rows, maHd) {
  return `
    ${tabHeader('Chi phí ghi nhận', 'Ghi nhận trích trước', `window.location.hash='#/chi-phi'`)}
    <div class="table-wrap"><table class="table">
      <thead><tr>
        <th>Số CT</th><th>Tên CP</th>
        <th class="num">Số tiền</th>
        <th>Loại CP</th><th>Phân loại IFRS</th>
        <th>Ngày CT</th><th>Trạng thái</th>
      </tr></thead>
      <tbody>
        ${(rows && rows.length)
          ? rows.map(r => `
            <tr data-href="#/chi-phi">
              <td><strong>${esc(r.so_ct || '')}</strong></td>
              <td class="small">${esc(r.ten_cp || '')}</td>
              <td class="num">${formatVND(r.tong_tt || r.thanh_tien || 0)}</td>
              <td class="small">${esc(r.loai_cp || '—')}</td>
              <td class="small">${esc(r.phan_loai || '—')}</td>
              <td class="small">${formatDate(r.ngay_ct)}</td>
              <td>${stateLabel(r.trang_thai)}</td>
            </tr>`).join('')
          : emptyRow(7, 'Chưa có chi phí nào ghi nhận cho HĐ này.')}
      </tbody>
    </table></div>`;
}

function renderPycTab(rows, maHd) {
  return `
    ${tabHeader('Phiếu yêu cầu thanh toán', 'Tạo phiếu YCTT', `window.location.hash='#/pyctt/new'`)}
    <div class="table-wrap"><table class="table">
      <thead><tr>
        <th>Số phiếu</th><th>Loại</th>
        <th class="num">Số tiền</th><th class="num">Chi trong kỳ</th>
        <th>Kỳ TT</th><th>Ngày YC</th><th>Trạng thái</th>
      </tr></thead>
      <tbody>
        ${(rows && rows.length)
          ? rows.map(r => `
            <tr data-href="#/pyctt">
              <td><strong>${esc(r.so_pyctt || '')}</strong></td>
              <td class="small">${LOAI_PYC[r.loai_pyc] || esc(r.loai_pyc || '—')}</td>
              <td class="num">${formatVND(r.so_tien || 0)}</td>
              <td class="num bold">${formatVND(r.chi_trong_ky || 0)}</td>
              <td class="small">${esc(r.ky_tt || '—')}</td>
              <td class="small">${formatDate(r.ngay_yc)}</td>
              <td>${stateLabel(r.trang_thai)}</td>
            </tr>`).join('')
          : emptyRow(7, 'Chưa có phiếu YCTT nào.')}
      </tbody>
    </table></div>`;
}

const LOAI_PYC = {
  thanh_toan: 'Thanh toán',
  tam_ung:    'Tạm ứng',
  ung_quy:    'Ứng quỹ'
};

function formatDate(s) {
  if (!s) return '—';
  try { return new Date(s).toLocaleDateString('vi-VN'); } catch (e) { return s; }
}
